import React from 'react'
import { Routes, Route } from 'react-router-dom'
import { HelmetProvider } from 'react-helmet-async'
import PublicRouter from './public/PublicRouter'
import AdminRouter from './admin/AdminRouter'
import Error from './_utils/Error'
import Card from './public/components/Card'
import GalerieCard from './public/components/GalerieCard'
import CGU from './public/components/CGU'
import Passerelle1 from './public/components/Passerelle1'
import Passerelle2 from './public/components/Passerelle2'
import ScrollToTop from './functions/ScrollToTop'

// styles
import './styles/m-app.css'
import './styles/t-d-app.css'

const App = () => {
    window.onload = () => {
        window.scrollTo(0, 0)
    }

    return (
        <div>
            <HelmetProvider>
                <Routes>
                    <Route exact path='/*' element={<PublicRouter />} />
                    <Route exact path='/copie-de-accueil' element={<Passerelle1 />} />
                    <Route exact path='/copie-de-en-savoir-plus' element={<Passerelle2 />} />
                    <Route path='/dashboard/*' element={<AdminRouter />} />
                    <Route path='/GalerieCard' element={<GalerieCard />} />
                    <Route path='/Card/:id' element={<Card />} />
                    <Route path='/CGU' element={<CGU />} />
                    <Route path='*' element={<Error />} />
                </Routes>
            </HelmetProvider>
            <ScrollToTop />
        </div>
    )
}

export default App